import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { KeyValuePair } from "../commonInterfaces";
import { Helper } from "../core/util/helper";
import { BaseColumn, EditableGrid, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid";
import { ToolBarInGridButtonType } from "../core/components/toolBar";
import { Dialog, DialogProps } from "../core/components/dialog";
import { ComponentHelper } from "../core/util/componentHelper";
import { DropDownList } from "../core/components/dropDownList";
import { FieldInstance } from "../core/components/field";
import React from "react";
import ReactDOM from "react-dom";

export default class PartsCS extends React.Component<PartsCSProps, any>{
    private common = new AppHelper();
    constructor(props: PartsCSProps) {
        super(props)
        const entity = props.entity;
        this.common.init(this);
    }

    save = async (closeAfterSave) => {
        const result = await HTTPService.post<JsonResultClass>("Parts/SaveCS", this.props.entity);
        if (result.Code === 0) {
            this.props.entity.IsNew = false;
            NotificationHelper.showSuccessMessage(result.Message);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        this.common.handlePostSave(result.Code === 0, closeAfterSave);
        this.setState({});
    }

    private handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }
    private renderGrid = () => {
        return <StockGrid data={this.props.entity.Stocks} states={this.props.dataSources.states} onChange={(data) => { this.handleFieldChange({ model: "entity.Stocks"}, data) }} warehouses={this.props.dataSources.warehouses} />
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface PartsCSProps extends AppBaseProps {
    entity: EntityPartsCS;
}

export interface EntityPartsCS extends Entity {
    ArtNr: number;
    ChargenNr: string;
    SerienNr: string;
    Kommentar: string;
    Menge: number;
    Stocks: Stock[];
}

interface Stock {
    Adrnr: string;
    Amount: number;
    ProblemNr: number;
    ProjNr: string;
    SpaceStorageId: number;
    State: number;
    WarehouseId: number;
}
interface StockGridProps {
    states: KeyValuePair<number, string>[];
    warehouses: { Id: number, Name: string, SpaceStorages: { Id: number, Name: string }[] }[];
    data: Stock[];
    onChange: (data: Stock[]) => void;
}
class StockGrid extends React.Component<StockGridProps, any>{
    private gridOptions;
    private NEW_BTN_ID = "new";
    private DELETE_BTN_ID = "delete";
    constructor(props) {
        super(props)

        this.initApp();
    }

    private initApp = () => {
        this.setOptions();
        //this.setState({});
    }

    private setOptions = () => {
        this.gridOptions = {
            columns: [
                {
                    type: "textBox",
                    field: "WarehouseId",
                    title: Helper.getTranslation("WebSMS.Warehouse"),
                    template: (item: Stock) => {
                        const warehouse = this.props.warehouses.find(x => x.Id == item.WarehouseId)
                        if (warehouse) {
                            return warehouse.Name;
                        }
                        return item.WarehouseId;
                    },
                    filterable: {
                        ui: this.filterWarehouses
                    },
                    readonly: true,
                },
                {
                    type: "textBox",
                    field: "SpaceStorageId",
                    title: Helper.getTranslation("WebSMS.Warehouse.StorageSpace"),
                    template: (item: Stock) => {
                        const warehouse = this.props.warehouses.find(x => x.Id == item.WarehouseId)
                        if (warehouse) {
                            const spaceStorage = warehouse.SpaceStorages.find(x => x.Id == item.SpaceStorageId)
                            if (spaceStorage)
                                return spaceStorage.Name;
                        }
                        return item.SpaceStorageId;
                    },
                    readonly: true,
                },
                {
                    type: "dropDown",
                    field: "State",
                    title: Helper.getTranslation("Field.Adresse.status"),
                    template: (item: Stock) => {
                        const state = this.props.states.find(x => x.Key == item.State)
                        if (state) {
                            return state.Value;
                        }
                        return item.State;
                    },
                    dataSource: "states",
                    dataTextField: "Value",
                    dataValueField: "Key",
                    optionLabel: "",
                    filterable: {
                        ui: this.filterStates
                    }
                },
                {
                    type: "numericTextBox",
                    field: "Amount",
                    title: Helper.getTranslation("Parts.ChargenSerien.Menge"),
                    required: false,
                    min: 0,
                    readonly: true
                },
                {
                    type: "addresssearch",
                    field: "Adrnr",
                    title: Helper.getTranslation("Adresse.Adresse"),
                    required: false

                },
                {
                    type: "ticketsearch",
                    field: "ProblemNr",
                    title: Helper.getTranslation("BrowserTitle.Ticket.Available"),
                    required: false
                },
                {
                    type: "projectsearch",
                    field: "ProjNr",
                    title: Helper.getTranslation("BrowserTitle.Project.Available"),
                    required: false
                }
            ]
        };
    }

    private filterStates = (element: any) => {
        element.kendoDropDownList({
            dataTextField: "Value",
            dataValueField: "Key",
            dataSource: this.props.states,
            optionLabel: Helper.getTranslation("Standard.BitteWählen")
        });
    }

    private filterWarehouses = (element: any) => {
        element.kendoDropDownList({
            dataTextField: "Name",
            dataValueField: "Id",
            dataSource: this.props.warehouses,
            optionLabel: Helper.getTranslation("Standard.BitteWählen")
        });
    }

    private onValueChange = (action, fieldName, dataItems: Stock[]) => {
        if (action != "itemchange" && fieldName != "result")
            return;
        const data = this.props.data;
        const index = data.findIndex(f => f.WarehouseId == dataItems[0].WarehouseId && f.SpaceStorageId == dataItems[0].SpaceStorageId)
        data[index][fieldName] = dataItems[0][fieldName];
        this.props.onChange(data);
    }

    private handleButtonClick = async (p: InGridButtonClickParams) => {
        switch (p.id) {
            case this.NEW_BTN_ID:
                const stock = await this.createNewStock()
                if (stock) {
                    const data = this.props.data;
                    data.push(stock);
                    this.props.onChange(data);
                    p.actions.add(stock);
                }
                break;
            case this.DELETE_BTN_ID:
                const data = this.props.data.filter(f1 => p.selectedItems.findIndex(f2 => f1.SpaceStorageId == f2.SpaceStorageId && f1.WarehouseId == f2.WarehouseId) == -1)
                this.props.onChange(data)
                p.actions.deleteSelected(false);
                break;
        }
    }

    private createNewStock = () => {
        return new Promise<Stock>((resolve) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);
            const root = ReactDOM["createRoot"](targetElement[0]);
            const removeDialog = () => {
                root.unmount(targetElement[0]);
                targetElement[0].remove();
            }
            const tmp = this.props.data.map(f => parseInt(f.SpaceStorageId.toString()));

            const warehouses = JSON.parse(JSON.stringify(this.props.warehouses));
            for (let i = 0; i < warehouses.length; i++) {
                warehouses[i].SpaceStorages = warehouses[i].SpaceStorages.filter(s => tmp.indexOf(s.Id) == -1)
            }


            const props: StockDialogProps = {
                onCancel: () => {
                    removeDialog();
                    resolve(null)
                },
                onOk: (warehouseId: number, spaceStorageId: number) => {
                    const stock: Stock = {
                        Adrnr: null,
                        Amount: 0,
                        ProblemNr: null,
                        ProjNr: null,
                        SpaceStorageId: spaceStorageId,
                        State: Math.min(...this.props.states.map(s => s.Key)),
                        WarehouseId: warehouseId
                    };
                    resolve(stock)
                    removeDialog();
                },
                warehouses: warehouses.filter(f => f.SpaceStorages.length > 0)
            };

            root.render(<StockDialog {...props} />);
        })
    }

    render() {
        const someId = "Stocks";

        let schema = new Schema();
        schema.Id = someId;

        const whatever: any = {
            ...this.props,
            dataSources: {
                states: this.props.states
            }
        };

        const buttons: Array<InGridToolBarButton> = [
            { type: ToolBarInGridButtonType.NEW, id: this.NEW_BTN_ID },
            { type: ToolBarInGridButtonType.DELETE, id: this.DELETE_BTN_ID }
        ];


        return (
            <div style={{ height: "500px" }}>
                <EditableGrid data={this.props.data}
                    id={someId}
                    schema={schema}
                    gridOptions={this.gridOptions}
                    editable={false}
                    onDataChanged={this.onValueChange}
                    validatable={false}
                    groupable={false}
                    filterable={true}
                    //buttons={buttons}
                    onButtonClick={this.handleButtonClick}
                    {...whatever}
                />
            </div>
        )
    }

}
interface StockDialogProps {
    warehouses: { Id: number, Name: string, SpaceStorages: { Id: number, Name: string }[] }[];
    onOk: (warehouseId: number, spaceStorage: number) => void;
    onCancel: () => void;
}
class StockDialog extends React.Component<StockDialogProps, { warehouseId: number, spaceStorageId: number }>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("Standard.Neu"),
        open: true,
        actions: [
            {
                label: Helper.getTranslation("WebSMS.TransEditor.ActionCancel"),
                action: () => {
                    this.props.onCancel()
                },
                primary: false
            },
            {
                label: Helper.getTranslation("Standard.OK"),
                action: () => {
                    this.props.onOk(this.state.warehouseId, this.state.spaceStorageId)
                },
                primary: true
            }
        ],
        afterClose: () => { },
        width: 400
    };

    constructor(props: StockDialogProps) {
        super(props)

        this.state = {
            spaceStorageId: props.warehouses[0].SpaceStorages[0].Id,
            warehouseId: props.warehouses[0].Id
        }
    }

    private renderDropDown = (field: "warehouseId" | "spaceStorageId") => {
        const props = this.factory.getDefaultDropDownProps();
        props.value = field == "warehouseId" ? this.state.warehouseId : this.state.spaceStorageId;
        props.onChange = (_, value: number) => {
            if (field == "warehouseId") {
                this.setState({ warehouseId: value, spaceStorageId: this.props.warehouses.find(f => f.Id == value).SpaceStorages[0].Id })
            } else {
                this.setState({ spaceStorageId: value })
            }
        }
        props.dataSource = field == "warehouseId" ? this.props.warehouses : this.props.warehouses.find(f => f.Id == this.state.warehouseId).SpaceStorages;
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.field.refreshDSOnRefChange = true;
        props.field.optionLabel = "";
        return (
            <>
                <FieldInstance label={Helper.getTranslation(field == "warehouseId" ? "WebSMS.Warehouse" : "WebSMS.Warehouse.StorageSpace")} noHover={true}>
                    <DropDownList {...props} />
                </FieldInstance>
            </>
        );
    }

    render() {
        return (
            <>
                <Dialog {...this.dialogProps} >
                    {this.renderDropDown("warehouseId")}
                    {this.renderDropDown("spaceStorageId")}
                </Dialog>
            </>
        );
    }
}